<template>
  <div style="width:100%">
    <Loading :value="loading"></Loading>
    <!-- RACOURCIS -->

    <v-card>

      <v-card-title style="padding: 0px">
        <v-layout row>
          <v-flex sm6>
            <v-breadcrumbs icons divider="chevron_right">
              <v-breadcrumbs-item>RECHERCHE GENERALE</v-breadcrumbs-item>
            </v-breadcrumbs>
          </v-flex>
        </v-layout>
      </v-card-title>
      
    </v-card>
    <br />
    <!-- RECHERCHER DES FACTURES -->

    <el-row :gutter="10">
      <div class="grid-content" style="padding:3px; margin:5px">    
        <el-row>

          <v-container fluid grid-list-md>
            <el-card class="box-card">

              <v-layout row class="mb-12">
                 
                 <v-flex md3 class="mr-1">
                   <el-select
                     clearable
                     filterable
                     v-on:change="loadChantier(projetS)"
                     v-model="projetS"
                     placeholder="Selectionner de Projet"
                     style="width:100%"
                   >
                     <el-option
                       v-for="item in listeProjet"
                       :key="item.id"
                       :label="item.libelle"
                       :value="item.id"
                     ></el-option>
                   </el-select>
                 </v-flex>

                 <v-flex md3 class="mr-1">
                   <el-select
                     clearable
                     filterable
                     v-model="chantierS"
                     placeholder="Selectionner un Chantier"
                     style="width:100%"
                   >
                     <el-option
                       v-for="item in listeChantier"
                       :key="item.id"
                       :label="item.libelle"
                       :value="item.id"
                     ></el-option>
                   </el-select>
                 </v-flex>

                 <v-flex md2 class="mr-1">                  
                   <el-select
                     clearable
                     filterable
                     @clear="clearSelect()"
                     @change="
                       filtrerEtatPrioriteBesoin
                     "
                     v-model="typeRech"
                     placeholder="Filtrer par type"
                   >
                     <el-option
                       v-for="item in priorites"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"
                     ></el-option>
                   </el-select>
                 </v-flex>

                 <v-flex md4 class="mr-1">                  
                   <el-select
                       clearable
                       filterable
                       multiple 
                       v-model="selectFourn"
                       placeholder="Filtrer par fournisseur"
                     >
                     <el-option v-for="item in listFourn" :key="item.id" :label="item.libelle" :value="item.id">
                       </el-option>
                   </el-select>
                 </v-flex>

               </v-layout>
               
               <v-layout row class="mb-12">
                 
                 <v-flex md3>                                                   
                   <el-date-picker
                     clearable
                     @clear="clearSelect()"
                     v-model="selectEtatDate"
                     type="daterange"
                     range-separator="à"
                     start-placeholder="date de debut"
                     end-placeholder="date de fin"
                     value-format="dd-MM-yyyy"
                     format="dd-MM-yyyy"
                   ></el-date-picker>
                 </v-flex>
                            
                 <v-flex md3 class="ml-5">
                  <el-input v-if="typeRech == 'commande'" clearable name="commande" placeholder="reference" v-model="reference"
                      style="width:100%"></el-input>
                  <el-input v-if="typeRech == 'facture'" clearable name="facture" placeholder="reference" v-model="reference"
                      style="width:100%"></el-input>
                  <el-input v-if="typeRech == 'livraison'" clearable name="livraison" placeholder="reference" v-model="reference"
                      style="width:100%"></el-input>                         
                 </v-flex>

                 <v-col cols="12" md="2" class="text-center" v-if="typeRech">
                  <el-button type="primary" icon="el-icon-search" @click="recherche()" >Rechercher</el-button>
                </v-col>
                 
               </v-layout>

          

              <!-- <v-form v-model="valid" ref="formRech" lazy-validation id="formRech">
                <v-layout row>
                  <el-date-picker
                          style="width: 100%"
                          v-model="formRecherche.periode"
                          format="dd-MM-yyyy"
                          value-format="yyyy-MM-dd"
                          type="datetimerange"
                          range-separator="à"
                          start-placeholder="Début date"
                          end-placeholder="Fin date"
                  ></el-date-picker>
                  <v-flex xs7>
                    <el-radio v-model="typeRech" label="commande">Commande</el-radio>
                    <el-radio v-model="typeRech" label="facture">Facture</el-radio>
                    <el-radio v-model="typeRech" label="livraison">Livraison</el-radio>
                    <el-radio v-model="typeRech" label="demandeFond">Demande de Fond</el-radio>
                  </v-flex>

                  <v-flex md4 v-if="typeRech == 'commande'">
                    <el-input clearable name="commande" placeholder="reference" v-model="formRecherche.commande"
                      style="width:100%"></el-input>
                  </v-flex>

                  <v-flex md4 v-if="typeRech == 'facture'">
                    <el-input clearable name="facture" placeholder="reference" v-model="formRecherche.facture"
                      style="width:100%"></el-input>
                  </v-flex>

                  <v-flex md4 v-if="typeRech == 'livraison'">
                    <el-input clearable name="livraison" placeholder="reference" v-model="formRecherche.livraison"
                      style="width:100%"></el-input>
                  </v-flex>

                  <v-flex md5 v-if="typeRech == 'commande' || typeRech == 'livraison' || typeRech == 'facture'">
                    <el-select filterable multiple clearable v-model="selectFourn" placeholder="Fournisseur">
                      <el-option v-for="item in listFourn" :key="item.id" :label="item.libelle" :value="item.id">
                      </el-option>
                    </el-select>
                  </v-flex>

                  <v-flex md5 v-if="typeRech == 'demandeFond'">
                    <el-select filterable clearable @clear="clearSelect()" v-model="formRecherche.projet" placeholder="Selectionner Projet"
                      style="width: 350px;" @change="Selection">
                      <el-option v-for="item in listeProjet" :key="item.id" :label="item.libelle" :value="item.id">
                      </el-option>
                    </el-select>
                  </v-flex> 

                  <v-flex md5 v-if="typeRech == 'demandeFond'">
                    <el-select filterable multiple clearable @clear="clearSelect()"  v-model="formRecherche.chantier" placeholder="Selectionner Chantier"
                      style="width: 350px">
                      <el-option v-for="item in listeChantier" :key="item.id" :label="item.libelle" :value="item.id">
                      </el-option>
                    </el-select>
                  </v-flex>

                  <v-flex md1>
                    <v-btn icons color="blue" @click="recherche()" fab dark small>
                      <v-icon>search</v-icon>
                    </v-btn>
                  </v-flex>

                </v-layout>
              </v-form> -->
            </el-card>
          </v-container>
        </el-row>
      </div>
      <br />
    </el-row>


    <!-- TAB CHANTIER -->
    <v-layout row>
      <v-flex sm12>
        <v-card class="elevation-4">

          <v-toolbar class="text-xs-center" color="cyan darken-2" dark>
            <v-toolbar-title>Resultat de la recherche {{ typeRech == 'demandeFond' ? 'Demande de fond': typeRech }}</v-toolbar-title>
          </v-toolbar>
          
          <v-card-title class="text-xs-center" style="height:auto;">

            <v-flex xs6 v-if="nomFourn">
              <v-chip label outline color="green darken-1" class="elevation-4 text-xs-left" style="width:100%">
                <span class="subheading">{{ typeRech == 'demandeFond' ? 'Demande de fond': typeRech  }} passée chez le fournisseur : &nbsp; </span> <span
                  class="title text-xs-left"> {{ nomFourn }} </span>
              </v-chip>
            </v-flex>

            <v-flex xs12 class="text-xs-right">

              <v-tooltip top>
                <v-btn v-if="showButon" slot="activator" color="orange" @click.stop="generateFile('pdf', 'simple')" dark>
                  Exporter en Pdf
                  <v-icon right>print</v-icon>
                </v-btn>Pdf
              </v-tooltip>

              <v-tooltip top>
                <v-btn v-if="showButonExcel" slot="activator" color="green" @click.stop="generateFile('excel', 'simple')"
                  dark>
                  Exporter en Excel
                  <v-icon right>file_upload</v-icon>
                </v-btn>Excel
              </v-tooltip>

            </v-flex><br>

            <el-table border :header-row-style="headerRowStyle" highlight-current-row :data="listResulat"
              :summary-method="getSumm" show-summary style="width: 100%" max-height="900px">

              <div v-if="typeRech != 'demandeFond'">              
                <el-table-column type="expand">               
                  <template slot-scope="props">
                    <div v-if="typeRech == 'commande' && props.row.commande">
                      <v-flex xs4 class="text-xs-right">
                        <v-chip color="orange" text-color="white" style="font-size:18px">
                          <v-avatar class="orange darken-4"> {{ props.row.commande.length }} </v-avatar>
                          Commande(s) trouvée(s)
                        </v-chip>
                      </v-flex>
                      <v-chip dark label color="purple" text-color="white">
                        <v-icon left>label </v-icon>
                        <span>COMMANDE</span>
                      </v-chip>
                      <el-table border highlight-current-row :header-row-style="headerRowStyle" class="elevation-2"
                        :data="props.row.commande" :summary-method="getSumm" show-summary style="width: 100%">

                        <el-table-column type="expand">
                          <template slot-scope="props">
                            <v-layout wrap class="elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4">
                              <v-flex xs12>
                                <span class="title">Liste des ressources</span>
                                <v-divider class="mt-4"></v-divider>
                                <v-layout row>
                                  <v-flex xs12 class="mr-1 mt-3">
                                    <!-- <div class="grid-content"> -->
                                    <!-- <v-flex xs12> -->
                                    <v-layout row wrap>
                                      <!-- <v-flex xs12> -->
                                      <el-table :row-class-name="tableRowClassName" :data="props.row.option" border
                                        highlight-current-row :header-row-style="headerRowStyle" class="elevation-2"
                                        show-summary style="width: 100%">
                                        <el-table-column prop="produit" label="Ressource" sortable style="width: 100%">
                                          <template slot-scope="scope">
                                            <v-chip text-color="white" label color="primary">
                                              {{
                                                  scope.row
                                                    .produit
                                              }}
                                            </v-chip>
                                          </template>
                                        </el-table-column>

                                        <el-table-column prop="prixUOld" label="Ancien prix" sortable>
                                          <template slot-scope="scope">
                                            <v-chip text-color="white" label color="red">
                                              {{
                                                  new Intl.NumberFormat(
                                                    "fr-FR"
                                                  ).format(
                                                    scope.row
                                                      .prixUOld
                                                  )
                                              }}
                                            </v-chip>
                                          </template>
                                        </el-table-column>

                                        <el-table-column prop="prix" label="Prix unitaire" sortable>
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                new Intl.NumberFormat(
                                                  "fr-FR"
                                                ).format(
                                                  scope.row
                                                    .prix
                                                )
                                            }}</span>
                                          </template>
                                        </el-table-column>

                                        <el-table-column prop="qte" label="Quantié">
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                new Intl.NumberFormat(
                                                  "fr-FR"
                                                ).format(
                                                  scope.row
                                                    .qte
                                                )
                                            }}</span>
                                          </template>
                                        </el-table-column>

                                        <el-table-column prop="unite" label="Unite">
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                scope.row
                                                  .unite
                                            }}</span>
                                          </template>
                                        </el-table-column>


                                        <el-table-column prop="remise" label="Remise %">
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                new Intl.NumberFormat(
                                                  "fr-FR"
                                                ).format(
                                                  scope.row
                                                    .remise
                                                )
                                            }}</span>
                                          </template>
                                        </el-table-column>

                                        <el-table-column prop="tva" label="Tva %">
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                new Intl.NumberFormat(
                                                  "fr-FR"
                                                ).format(
                                                  scope.row
                                                    .tva
                                                )
                                            }}</span>
                                          </template>
                                        </el-table-column>

                                        <el-table-column prop="total" label="Total TTC (FCFA)">
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                new Intl.NumberFormat(
                                                  "fr-FR"
                                                ).format(
                                                  scope.row
                                                    .total
                                                )
                                            }}</span>
                                          </template>
                                        </el-table-column>


                                      </el-table>
                                      <!-- </v-flex> -->
                                    </v-layout>
                                    <!-- </v-flex> -->
                                    <!-- </div> -->
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" prop="ref" sortable label="Réference">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="primary">
                              {{ scope.row.ref }}
                            </v-chip>
                          </template>

                        </el-table-column>
                        <el-table-column align="center" sortable prop="libelle" label="projet/chantier/travaux">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="orange">
                              {{ scope.row.projet }} / {{ scope.row.chantier }} /{{ scope.row.travaux }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" sortable prop="libelle" label="Description">

                        </el-table-column>
                        <el-table-column align="center" sortable prop="userCreated" label="Crée par">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="orange">
                              {{ scope.row.userCreated }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" sortable prop="created" label="Date de création">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="primary">
                              {{ scope.row.created }}
                            </v-chip>
                          </template>
                        </el-table-column>

                        <el-table-column align="center" sortable prop="totalCommande" label="Montant">
                          <template slot-scope="prop3">
                            <el-tag class="subheading">{{ new Intl.NumberFormat().format(prop3.row.totalCommande) }} FCFA
                            </el-tag>
                          </template>
                        </el-table-column>

                        <el-table-column align="center" sortable prop="etat" label="Etat">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="green" v-if="scope.row.factureValide === 1">
                              FACTURE VALIDE<v-icon right></v-icon>
                            </v-chip>
                            <v-chip text-color="white" label color="red" v-if="scope.row.factureValide === 2">
                              FACTURE REJETE<v-icon right></v-icon>
                            </v-chip>
                            <v-chip text-color="white" label color="red" v-if="scope.row.etat === false">
                              NON LIVRE<v-icon right></v-icon>
                            </v-chip>
                            <v-chip text-color="white" label color="green" v-if="scope.row.etat == true">
                              LIVRE EN TOTALITE<v-icon right></v-icon>
                            </v-chip>
                          </template>
                        </el-table-column>

                      </el-table>
                    </div>

                    <br />
                    <div v-if="typeRech == 'facture' && props.row.facture">

                      <v-flex xs4 class="text-xs-right">
                        <v-chip color="orange" text-color="white" style="font-size:18px">
                          <v-avatar class="orange darken-4"> {{ props.row.facture.length }} </v-avatar>
                          Facture(s) trouvée(s)
                        </v-chip>
                      </v-flex>

                      <v-chip dark label color="purple" text-color="white">
                        <v-icon left>label </v-icon>
                        <span>DEVIS/FACTURE</span>
                      </v-chip>
                      <el-table border highlight-current-row :header-row-style="headerRowStyle" class="elevation-2"
                        :data="props.row.facture" :summary-method="getSumm" show-summary style="width: 100%">

                        <el-table-column type="expand">
                          <template slot-scope="props">
                            <v-layout wrap class="elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4">
                              <v-flex xs12>
                                <span class="title">Liste des ressources</span>
                                <v-divider class="mt-4"></v-divider>
                                <v-layout row>
                                  <v-flex xs12 class="mr-1 mt-3">
                                    <!-- <div class="grid-content"> -->
                                    <!-- <v-flex xs12> -->
                                    <v-layout row wrap>
                                      <!-- <v-flex xs12> -->
                                      <el-table :row-class-name="tableRowClassName" :data="props.row.option" border
                                        highlight-current-row :header-row-style="headerRowStyle" class="elevation-2"
                                        show-summary style="width: 100%">
                                        <el-table-column prop="produit" label="Ressource" sortable style="width: 100%">
                                          <template slot-scope="scope">
                                            <v-chip text-color="white" label color="primary">
                                              {{
                                                  scope.row
                                                    .produit
                                              }}
                                            </v-chip>
                                          </template>
                                        </el-table-column>

                                        <el-table-column prop="prix" label="Prix unitaire" sortable>
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                new Intl.NumberFormat(
                                                  "fr-FR"
                                                ).format(
                                                  scope.row
                                                    .prix
                                                )
                                            }}</span>
                                          </template>
                                        </el-table-column>


                                        <el-table-column prop="qte" label="Quantié">
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                new Intl.NumberFormat(
                                                  "fr-FR"
                                                ).format(
                                                  scope.row
                                                    .qte
                                                )
                                            }}</span>
                                          </template>
                                        </el-table-column>

                                        <el-table-column prop="unite" label="Unite">
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                scope.row
                                                  .unite
                                            }}</span>
                                          </template>
                                        </el-table-column>


                                        <el-table-column prop="remise" label="Remise %">
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                scope.row
                                                  .remise
                                            }}</span>
                                          </template>
                                        </el-table-column>

                                        <el-table-column prop="tva" label="Tva %">
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                scope.row
                                                  .tva
                                            }}</span>
                                          </template>
                                        </el-table-column>

                                        <el-table-column prop="total" label="Total TTC (FCFA)">
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                new Intl.NumberFormat(
                                                  "fr-FR"
                                                ).format(
                                                  scope.row
                                                    .total
                                                )
                                            }}</span>
                                          </template>
                                        </el-table-column>


                                      </el-table>
                                      <!-- </v-flex> -->
                                    </v-layout>
                                    <!-- </v-flex> -->
                                    <!-- </div> -->
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </template>
                        </el-table-column>

                        <el-table-column align="center" prop="ref" sortable label="Réference">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="primary">
                              {{ scope.row.ref }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" sortable prop="libelle" label="projet/chantier/travaux">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="orange">
                              {{ scope.row.projet }} / {{ scope.row.chantier }} / {{ scope.row.travaux }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" sortable prop="libelle" label="Description">

                        </el-table-column>
                        <el-table-column align="center" sortable prop="created" label="Date de création">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="primary">
                              {{ scope.row.created }}
                            </v-chip>
                          </template>
                        </el-table-column>

                        <el-table-column align="center" sortable prop="total" label="Montant">
                          <template slot-scope="prop3">
                            <el-tag class="subheading">{{ new Intl.NumberFormat().format(prop3.row.total) }} FCFA</el-tag>
                          </template>
                        </el-table-column>

                        <el-table-column align="center" sortable prop="etat" label="Etat">
                          <template slot-scope="scope">
                            <v-chip outline text-color="orange" label color="orange" v-if="scope.row.etatFact === 0">
                              EN ATTENTE DE VALIDATION<v-icon right></v-icon>
                            </v-chip>
                            <v-chip outline text-color="green" label color="green" v-if="scope.row.etatFact === 1">
                              VALIDE<v-icon right></v-icon>
                            </v-chip>
                            <v-chip outline text-color="red" label color="red" v-if="scope.row.etatFact === 2">
                              REJETE<v-icon right></v-icon>
                            </v-chip>
                            <v-chip v-if="scope.row.etat === 'IMPAYE'" text-color="white" label color="red">
                              {{ scope.row.etat }}
                            </v-chip>
                            <v-chip v-if="scope.row.etat === 'PAYE'" text-color="white" label color="green">
                              {{ scope.row.etat }}
                            </v-chip>
                            <v-chip v-if="scope.row.etat === 'EN COURS DE PAIEMENT'" text-color="white" label
                              color="orange">
                              {{ scope.row.etat }}
                            </v-chip>
                            <v-chip v-if="scope.row.etat === 'EN ATTENTE DE PAIEMENT'" text-color="white" label
                              color="primary">
                              {{ scope.row.etat }}
                            </v-chip>
                          </template>
                        </el-table-column>

                      </el-table>
                    </div>

                    <div v-if="typeRech == 'livraison' && props.row.livraison">
                      <v-flex xs4 class="text-xs-right">
                        <v-chip color="orange" text-color="white" style="font-size:18px">
                          <v-avatar class="orange darken-4"> {{ props.row.livraison.length }} </v-avatar>
                          Livraison(s) trouvée(s)
                        </v-chip>
                      </v-flex>

                      <v-chip dark label color="purple" text-color="white">
                        <v-icon left>label </v-icon>
                        <span>LIVRAISON</span>
                      </v-chip>
                      <el-table border highlight-current-row :header-row-style="headerRowStyle" class="elevation-2"
                        :data="props.row.livraison" :summary-method="getSumm" show-summary style="width: 100%">

                        <el-table-column type="expand">
                          <template slot-scope="props">
                            <v-layout wrap class="elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4">
                              <v-flex xs12>
                                <span class="title">Liste des ressources livrées</span>
                                <v-divider class="mt-4"></v-divider>
                                <v-layout row>
                                  <v-flex xs12 class="mr-1 mt-3">
                                    <!-- <div class="grid-content"> -->
                                    <!-- <v-flex xs12> -->
                                    <v-layout row wrap>
                                      <!-- <v-flex xs12> -->
                                      <el-table :row-class-name="tableRowClassName" :data="props.row.livre" border
                                        highlight-current-row :header-row-style="headerRowStyle" class="elevation-2"
                                        show-summary style="width: 100%">
                                        <el-table-column prop="produit" label="Ressource" sortable style="width: 100%">
                                          <template slot-scope="scope">
                                            <v-chip text-color="white" label color="primary">
                                              {{
                                                  scope.row
                                                    .produit
                                              }}
                                            </v-chip>
                                          </template>
                                        </el-table-column>

                                        <el-table-column prop="qteL" label="Quantité livré" sortable>
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                scope.row
                                                  .qteL
                                            
                                            }}</span>
                                          </template>
                                        </el-table-column>

                                        <el-table-column prop="qteR" label="Quantité restant">
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                scope.row
                                                  .qteR
                                            }}</span>
                                          </template>
                                        </el-table-column>

                                        <el-table-column prop="prixU" label="Prix unitaire">
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                new Intl.NumberFormat(
                                                  "fr-FR"
                                                ).format(
                                                  scope.row
                                                    .prixU)
                                            }}</span>
                                          </template>
                                        </el-table-column>

                                        <el-table-column prop="remise" label="Remise">
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{ scope.row
                                                .remise
                                            }}</span>
                                          </template>
                                        </el-table-column>

                                        <el-table-column prop="tva" label="Tva %">
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{ scope.row.tva }}</span>
                                          </template>
                                        </el-table-column>


                                        <el-table-column prop="totalTtc" label="Total TTC">
                                          <template slot-scope="scope">
                                            <span class="grey--text title">{{
                                                new Intl.NumberFormat(
                                                  "fr-FR"
                                                ).format(
                                                  scope.row
                                                    .totalTtc)
                                            }}</span>
                                          </template>
                                        </el-table-column>
                                      </el-table>
                                      <!-- </v-flex> -->
                                    </v-layout>
                                    <!-- </v-flex> -->
                                    <!-- </div> -->
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </template>
                        </el-table-column>


                        <el-table-column align="center" prop="ref" sortable label="Réference">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="primary">
                              {{ scope.row.ref }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" sortable prop="comRef" label="Ref commande">
                          <template slot-scope="scope">
                            <v-chip outline text-color="primary" label color="primary">
                              {{ scope.row.comRef }} {{ scope.row.libelle }} <v-icon right></v-icon>
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" sortable prop="refact" label="Ref facture">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="orange">
                              {{ scope.row.refact }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" sortable prop="created" label="Date de création">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="primary">
                              {{ scope.row.created }}
                            </v-chip>
                          </template>
                        </el-table-column>
                        <el-table-column align="center" sortable prop="etat" label="Etat">
                          <template slot-scope="scope">
                            <v-chip v-if="scope.row.etat === false" outline text-color="orange" label color="orange">
                              PARTIELLEMENT LIVRE <v-icon right></v-icon>
                            </v-chip>
                            <v-chip v-if="scope.row.etat === true" outline text-color="green" label color="green">
                              TOTALEMENT LIVRE <v-icon right></v-icon>
                            </v-chip>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>

                    <br />
                    <!-- <div v-if="typeRech == 'demandeFond'">
                      Réference: 
                      <el-table-column align="center" prop="ref" sortable label="Réference">
                          <template slot-scope="scope">
                            <v-chip text-color="white" label color="primary">
                              {{ scope.row.ref }}
                            </v-chip>
                          </template>
                        </el-table-column>
                    </div> -->

                  </template>
                </el-table-column>

                <el-table-column align="center" sortable prop="fournisseurNom" label="Fournisseur">
                  <template slot-scope="prop">
                    <span v-if="typeof (prop.row.fournisseurNom) == 'object' " v-for="(item, index) in prop.row.fournisseurNom" :key="index">
                      <v-chip outline text-color="green" label> {{ item }}</v-chip>/
                    </span>
                    <span v-if="typeof (prop.row.fournisseurNom) == 'string'" class="subheading black--text">
                      {{ prop.row.fournisseurNom }}
                    </span>
                  </template>
                </el-table-column>
                                    
                <el-table-column align="center" sortable v-if="typeRech != 'livraison'"
                  prop="totalGlobal" label="Total commande">
                  <template slot-scope="prop">
                    <el-tag class="subheading" type="warning">
                      {{ new Intl.NumberFormat().format(prop.row.totalGlobal) }} FCFA
                    </el-tag>
                  </template>
                </el-table-column>
              </div>

              <div v-if="typeRech == 'demandeFond'">  
                <el-table-column type="expand">                                                 
                </el-table-column>

                <el-table-column align="center" prop="projet" sortable label="Projet / Chantier">
                  <template slot-scope="scope">
                    <v-chip text-color="white" label color="primary">
                        {{ scope.row.projet }} /  {{ scope.row.chantier }}
                    </v-chip>
                  </template>
                </el-table-column>      

                <el-table-column align="center" sortable prop="demandeur" label="Demandeur">
                  <template slot-scope="prop">
                    <span class="subheading black--text">
                      {{ prop.row.demandeur }}
                    </span>
                  </template>
                </el-table-column>   

                <el-table-column align="center" sortable prop="montant"
                  label="Montant demandé">
                  <template slot-scope="prop">
                    <el-tag class="subheading" type="warning">
                      {{ new Intl.NumberFormat().format(prop.row.montant) }} FCFA
                    </el-tag>
                  </template>
                </el-table-column>

                <el-table-column align="center" sortable prop="dateFormat"
                  label="Date de demande">
                  <template slot-scope="prop">
                    <el-tag class="subheading" type="warning">
                      {{ prop.row.dateFormat }}
                    </el-tag>
                  </template>
                </el-table-column>

                <el-table-column align="center" prop="motif" sortable label="Motif">
                  <template slot-scope="scope">
                    <span class="subheading black--text">
                      {{ scope.row.motif }}
                    </span>
                  </template>
                </el-table-column>
              </div>

            </el-table>
          </v-card-title>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- MODAL SHOW COMMANDE -->
    <v-dialog v-model="dialogShowCommande" max-width="80%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span>Détails de la commande {{ detailCommande.ref }} {{ detailCommande.libelle }} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowCommande = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loading" element-loading-text="Veuillez patientez ..."
          element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <el-row :gutter="20" style="padding:10px;">
            <el-col :span="12">
              <el-card class="box-card">
                <div class="grid-content" style="padding:3px;">
                  <el-row>
                    <div class="text item">
                      <v-layout row justify>
                        <v-flex md6>
                          <p><b>Identifiant : </b> {{ detailCommande.ref }} </p>
                          <p><b>Libellé : </b> {{ detailCommande.libelle }} </p>
                          <p><b>Date de la commande : </b> {{ detailCommande.dateC }} </p>
                          <p><b>Date de la livraison : </b> {{ detailCommande.dateLivr }} </p>
                          <p><b>Statut : </b>
                            <v-chip outline text-color="orange" label color="orange"
                              v-if="detailCommande.factureValide === 0">
                              EN ATTENTE DE VALIDATION<v-icon right></v-icon>
                            </v-chip>
                            <v-chip outline text-color="green" label color="green"
                              v-if="detailCommande.factureValide === 1">
                              VALIDE<v-icon right></v-icon>
                            </v-chip>
                            <v-chip outline text-color="red" label color="red"
                              v-if="detailCommande.factureValide === 2">
                              REJETE<v-icon right></v-icon>
                            </v-chip>
                          </p>
                          <p><b>Enregistré par: </b> {{ detailCommande.userCreated }} </p>
                        </v-flex>
                        <v-flex md6>
                          <p><b>Etat : </b>
                            <v-chip outline text-color="red" label color="red" v-if="detailCommande.etat === false">
                              NON LIVRE<v-icon right></v-icon>
                            </v-chip>
                            <v-chip outline text-color="green" label color="green" v-if="detailCommande.etat == true">
                              LIVRE EN TOTALITE<v-icon right></v-icon>
                            </v-chip>
                          </p>
                          <p><b>Date d'enregistrement : </b> {{ detailCommande.created }} </p>
                          <p><b>Date de modification : </b> {{ detailCommande.modified }} </p>
                          <p><b>Projet : </b> {{ detailCommande.projet }} </p>
                          <p><b>Modalité : </b> {{ detailCommande.modalite }} </p>
                          <p><b>Avance démarage(%) : </b> {{ detailCommande.avance }} </p>
                        </v-flex>
                      </v-layout>
                      <v-layout v-if="detailCommande.compare == 2" row justify>
                        <v-flex xs6 class="text-xs-right title">
                          <a href="#" target=_blank>
                            <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img
                                src="static/validComparateur.png"></v-avatar>
                          </a>
                        </v-flex>
                      </v-layout>
                    </div>
                  </el-row>
                  <el-row>
                    <el-table stripe :data="detailCommande.user" style="width: 100%">
                      <el-table-column prop="nom" label="Personnes concernées" width="180"></el-table-column>
                    </el-table>
                  </el-row>
                </div>
              </el-card>
            </el-col>

            <el-col :span="12">
              <el-card class="box-card">
                <div class="grid-content" style="padding:3px;">
                  <el-row>
                    <div class="text item">
                      <v-layout wrap justify>
                        <v-flex md12>
                          <v-chip outline text-color="primary" label color="primary" style="font-size:29px">
                            MONTANT REMISE : {{ totalComRemise }} FCFA
                          </v-chip>
                        </v-flex>
                        <v-flex md12>
                          <v-chip outline text-color="primary" label color="primary" style="font-size:29px">
                            MONTANT HT : {{ totalComHT }} FCFA
                          </v-chip>
                        </v-flex>
                      </v-layout>
                      <v-layout row justify>
                        <v-flex md12>
                          <v-chip outline text-color="primary" label color="primary" style="font-size:29px">
                            MONTANT TVA : {{ totalComTVA }} FCFA
                          </v-chip>
                        </v-flex>
                      </v-layout>
                      <v-layout row justify>
                        <v-flex md12>
                          <v-chip outline text-color="orange" label color="orange" style="font-size:29px">
                            MONTANT TTC : {{ detailCommande.total }} FCFA
                          </v-chip>
                        </v-flex>
                      </v-layout>
                    </div>
                  </el-row>
                </div>
              </el-card>
            </el-col>

            <el-card>
              <v-card>
                <img height="100px" :src='detailCommande.imgCommande' :alt="detailCommande.imgCommande" />
                <v-card-actions>
                  <v-btn target="_blank" :href="detailCommande.imgCommande" flat color="orange">Voir le document</v-btn>
                </v-card-actions>
              </v-card>
            </el-card>
          </el-row>

          <el-row :gutter="7" style="padding:10px;">
            <el-card class="box-card">
              <div class="grid-content" style="padding: 3px">
                <el-row>
                  <template>
                    <el-table :data="detailCommande.option" height="250" style="width: 100%">
                      <el-table-column prop="produit" label="Ressource" width="180"></el-table-column>
                      <el-table-column prop="tva" label="TVA (18%)" width="180"></el-table-column>
                      <el-table-column prop="prix" label="Prix unitaire (FCFA)"></el-table-column>
                      <el-table-column prop="qte" label="Quantité"></el-table-column>
                      <el-table-column prop="remise" label="Remise(%)"></el-table-column>
                      <el-table-column prop="unite" label="Unité"></el-table-column>
                      <el-table-column prop="total" label="Total TTC (FCFA)"></el-table-column>
                    </el-table>
                  </template>
                </el-row>
              </div>
            </el-card>
          </el-row>

          <el-row v-if="optionLivr.length > 1" :gutter="7" style="padding:10px;">
            <p align="center">
              <v-chip text-color="white" label color="primary" style="font-size: 25px">
                TOUTES LES LIVRAISONS CONCERNANT LA COMMANDE <v-icon right>redeem</v-icon>
              </v-chip>
            </p>
            <el-card class="box-card">
              <div class="grid-content" style="padding: 3px">
                <el-row>
                  <el-table :data="optionLivr" height="250" style="width: 100%">
                    <el-table-column prop="id" label="Référence" width="180"></el-table-column>
                    <el-table-column prop="etat" label="Etat" width="180">
                      <template slot-scope="scope">
                        <v-chip outline v-if="scope.row.etat === true" text-color="green" label color="green">
                          TOTALEMENT LIVRE
                        </v-chip>
                        <v-chip outline v-if="scope.row.etat === false" text-color="orange" label color="orange">
                          PARTIELLEMENT LIVRE
                        </v-chip>
                      </template>
                    </el-table-column>
                    <el-table-column prop="livreur" label="Livreur"></el-table-column>
                    <el-table-column prop="date" label="Date de livraison"></el-table-column>
                    <el-table-column label="Action">
                      <template slot-scope="scope">
                        <el-popover trigger="click" placement="left">
                          <div slot="reference" class="name-wrapper">
                            <el-button size="mini" type="primary">Détails</el-button>
                          </div>
                          <p>Livreur : {{ scope.row.livreur }}</p>
                          <p>Date de livraison: {{ scope.row.date }}</p>

                          <el-table :data="scope.row.livre" height="250" style="width: 100%">
                            <el-table-column prop="produit" label="Ressource" width="180"></el-table-column>
                            <el-table-column prop="qteL" label="Quantité livré" width="180"></el-table-column>
                            <el-table-column prop="qteR" label="Quantité restant"></el-table-column>
                          </el-table>
                        </el-popover>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </div>
            </el-card>
          </el-row>

          <v-tooltip top>
            <v-btn slot="activator" icons color="error" @click.stop="dialogShowCommande = false" dark>Fermer <v-icon
                right>close</v-icon>
            </v-btn>
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn slot="activator" icons color="orange" @click.stop="imprimerCommande(detailCommande);" dark>Imprimer
              <v-icon right>print</v-icon>
            </v-btn>
            Imprimer le bon de commande
          </v-tooltip>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW FACTURE -->
    <v-dialog v-model="dialogShowFacture" max-width="80%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span>Détails de la facture {{ detailFacture.ref }} {{ detailFacture.libelle }} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowFacture = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loading" element-loading-text="Veuillez patientez ..."
          element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <el-row :gutter="20" style="padding:10px;">
            <el-col :span="14">
              <el-card class="box-card">
                <div class="grid-content" style="padding:3px;">
                  <el-row>
                    <div class="text item">
                      <el-alert title="Vous ne pouvez pas modifier une facture issue d'une commande" type="warning"
                        :closable="false" center show-icon>
                      </el-alert>
                      <v-layout row justify>
                        <v-flex md6>
                          <p><b>Identifiant : </b> {{ detailFacture.ref }} </p>
                          <p><b>Libellé : </b> {{ detailFacture.libelle }} </p>
                          <p><b>Référence commande : </b> {{ detailFacture.refCom }} </p>
                          <p v-if="detailFacture.typeFact === true"><b>Commande concerné : </b> COM-{{ detailFacture.id }}
                          </p>
                          <p v-if="detailFacture.typeFact === false"><b>Maintenance concerné : </b>
                            MAIN-{{ detailFacture.id }} </p>
                          <p v-if="detailFacture.typeFact === true"><b>Date de la commande : </b>
                            {{ detailFacture.dateC }} </p>
                          <p><b>Total ttc de la facture : </b> {{ detailFacture.total }} FCFA</p>
                          <p><b>Statut : </b>
                            <v-chip outline text-color="orange" label color="orange"
                              v-if="detailFacture.etatFact === 0">
                              EN ATTENTE DE VALIDATION<v-icon right></v-icon>
                            </v-chip>
                            <v-chip outline text-color="green" label color="green" v-if="detailFacture.etatFact === 1">
                              VALIDE<v-icon right></v-icon>
                            </v-chip>
                            <v-chip outline text-color="red" label color="red" v-if="detailFacture.etatFact === 2">
                              REJETE<v-icon right></v-icon>
                            </v-chip>
                          </p>
                          <p><b>Enregistré par : </b> {{ detailFacture.userCreated }} </p>
                        </v-flex>
                        <v-flex md6>
                          <p><b>Caisse concerné : </b> {{ detailFacture.libelleCaisse }} </p>
                          <p v-if="detailFacture.modalite !== null"><b>Modalité de règlement : </b>
                            {{ detailFacture.modalite }}
                          </p>
                          <p v-if="detailFacture.avance !== null"><b>Avance demarage : </b>
                            {{ detailFacture.avance }}
                          </p>
                          <p v-if="detailFacture.datePaie !== null"><b>Date de paiement : </b>
                            {{ detailFacture.datePaie }} </p>
                          <p v-if="detailFacture.remarqueFact !== null"><b>Remarque : </b>
                            {{ detailFacture.remarqueFact }} </p>
                          <p><b>Date d'enregistrement : </b> {{ detailFacture.created }} </p>
                          <p><b>Date de modification : </b> {{ detailFacture.modified }} </p>
                        </v-flex>
                      </v-layout>
                    </div>
                  </el-row>
                </div>
              </el-card>
            </el-col>
            <el-col :span="10">
              <el-card class="box-card">
                <div class="grid-content" style="padding:3px;">
                  <el-row>
                    <div class="text item">
                      <v-layout wrap justify>
                        <v-flex md12>
                          <v-chip outline text-color="primary" label color="primary" style="font-size:23px">
                            MONTANT REMISE : {{ totalComRemise }} FCFA
                          </v-chip>
                        </v-flex>
                        <v-flex md12>
                          <v-chip outline text-color="primary" label color="primary" style="font-size:23px">
                            MONTANT HT : {{ totalComHT }} FCFA
                          </v-chip>
                        </v-flex>
                      </v-layout>
                      <v-layout row justify>
                        <v-flex md12>
                          <v-chip outline text-color="primary" label color="primary" style="font-size:23px">
                            MONTANT TVA : {{ totalComTVA }} FCFA
                          </v-chip>
                        </v-flex>
                      </v-layout>
                      <v-layout row justify>
                        <v-flex md12>
                          <v-chip outline text-color="orange" label color="orange" style="font-size:23px">
                            MONTANT TTC : {{ detailFacture.total }} FCFA
                          </v-chip>
                        </v-flex>
                      </v-layout>
                    </div>
                  </el-row>
                  <el-row>
                    <v-layout row v-if="detailFacture.imagefact != ''">
                      <v-flex xs3 class="ml-3  elevation-5 ">
                        <a :href="detailFacture.imagefact" target=_blank>
                          <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4"> <img
                              :src="detailFacture.imagefact"></v-avatar>
                        </a>
                      </v-flex>
                    </v-layout>
                  </el-row>
                </div>
              </el-card>
            </el-col>
          </el-row>

          <el-row :gutter="7" style="padding:10px;">
            <el-card class="box-card">
              <div class="grid-content" style="padding: 3px">
                <el-row>
                  <template>
                    <el-table :data="detailFacture.option" height="250" style="width: 100%">
                      <el-table-column prop="produit" label="Ressource" width="180"></el-table-column>
                      <el-table-column prop="tva" label="TVA(%) " width="180"></el-table-column>
                      <el-table-column prop="prix" label="Prix unitaire (FCFA)"></el-table-column>
                      <el-table-column prop="qte" label="Quantité"></el-table-column>
                      <el-table-column prop="remise" label="Remise(%)"></el-table-column>
                      <el-table-column prop="unite" label="Unité"></el-table-column>
                      <el-table-column prop="total" label="Total TTC (FCFA)"></el-table-column>
                    </el-table>
                  </template>
                </el-row>
              </div>
            </el-card>
          </el-row>

          <v-tooltip top>
            <v-btn slot="activator" icons color="error" @click.stop="dialogShowFacture = false" dark>Fermer <v-icon
                right>close</v-icon>
            </v-btn>
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn slot="activator" icons color="orange" @click.stop="imprimerFacture(detailFacture);" dark>Imprimer
              <v-icon right>print</v-icon>
            </v-btn>
            Imprimer la facture
          </v-tooltip>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW LIVRAISON -->
    <v-dialog v-model="dialogShowLivraison" max-width="70%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span>Détails de la livraison {{ livraisonCourant.ref }} {{ livraisonCourant.libelle }} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowLivraison = false, showBoat = false, showConteneurs = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loading" element-loading-text="Veuillez patientez ..."
          element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <el-row :gutter="20" style="padding:10px;">
            <el-col>
              <el-card class="box-card">
                <div class="grid-content" style="padding:3px;">
                  <el-row>
                    <div class="text item">
                      <v-layout row justify>
                        <v-flex md6>
                          <p><b>Identifiant : </b> {{ livraisonCourant.ref }} </p>
                          <p><b>Référence facture : </b> {{ livraisonCourant.refact }}</p>
                          <p><b>Référence commande : </b> {{ livraisonCourant.comRef }} {{ livraisonCourant.libelle }}</p>
                          <p><b>Date de la livraison : </b> {{ livraisonCourant.created }} </p>
                        </v-flex>
                        <v-flex md6>
                          <p><b>Etat : </b>
                            <v-chip text-color="white" label color="red" v-if="livraisonCourant.etat === false">
                              PARTIELLEMENT LIVRE<v-icon right></v-icon>
                            </v-chip>
                            <v-chip text-color="white" label color="green" v-if="livraisonCourant.etat === true">
                              TOTALEMENT LIVRE<v-icon right></v-icon>
                            </v-chip>
                          </p>
                          <p><b>Date d'enregistrement : </b> {{ livraisonCourant.created }} </p>
                          <p><b>Date de modification : </b> {{ livraisonCourant.modified }} </p>
                        </v-flex>
                      </v-layout>
                    </div>
                  </el-row>
                </div>
              </el-card>
            </el-col>
          </el-row>

          <el-row :gutter="7" style="padding:10px;">
            <el-card class="box-card">
              <v-card>
                <img height="100px" :src='livraisonCourant.imgLivraison' :alt="livraisonCourant.imgLivraison" />
                <v-card-actions>
                  <v-btn target="_blank" :href="livraisonCourant.imgLivraison" flat color="orange">Voir le document
                  </v-btn>
                </v-card-actions>
              </v-card>
            </el-card>
          </el-row>


          <el-row :gutter="7" style="padding:10px;">
            <el-card class="box-card">
              <div class="grid-content" style="padding: 3px">
                <el-row>
                  <template>
                    <el-table :data="livraisonCourant.livre" height="250" style="width: 100%">
                      <el-table-column prop="produit" label="Ressource" width="280"></el-table-column>
                      <el-table-column prop="qteL" label="Quantité livré"></el-table-column>
                      <el-table-column prop="qteR" label="Quantité restant"></el-table-column>
                    </el-table>
                  </template>
                </el-row>
              </div>
            </el-card>
          </el-row>

          <el-row :gutter="20" v-if="showBoat" style="padding:10px;">
            <el-col>
              <el-card class="box-card">
                <div class="grid-content" style="padding:3px;">
                  <el-row>
                    <div class="text item">
                      <v-layout row justify>
                        <v-flex md6>
                          <p><b>Reference export : </b> {{ detailLivraison[0].export }} </p>
                          <p><b>Numéro de commande : </b> {{ detailLivraison[0].numComBat }} </p>
                          <p><b>Numéro BL : </b> {{ detailLivraison[0].numBonLivraison }} </p>
                          <p><b>Lieu de réception : </b> {{ detailLivraison[0].recepetionConteneur }} </p>
                        </v-flex>
                        <v-flex md6>
                          <p><b>Numéro de chargement : </b>
                            {{ detailLivraison[0].numCpteLivraison }}
                          </p>
                          <p><b>Numéro de voyage : </b>
                            {{ detailLivraison[0].numVoyage }}
                          </p>
                          <p><b>Date d'enregistrement : </b> {{ detailLivraison[0].created }} </p>
                          <p><b>Date de modification : </b> {{ detailLivraison[0].modified }} </p>
                        </v-flex>
                      </v-layout>
                    </div>
                  </el-row>
                </div>
              </el-card>
            </el-col>
          </el-row>

          <el-row :gutter="20" v-if="showConteneurs" style="padding:10px;">
            <el-table :data="detailLivraison[0].conteneurs" style="width: 100%">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <el-row>
                    <el-col :span="5">
                      <div class="grid-content bg-purple">

                        <b>Description</b> : <p>{{ props.row.description }}</p>

                      </div>
                    </el-col>

                    <el-col :span="19">
                      <div>
                        <b>Articles</b> :
                      </div>
                      <div class="elevation-3">
                        <el-table :data="props.row.articles" style="width: 100%">
                          <el-table-column prop="code" label="Code">
                          </el-table-column>
                          <el-table-column prop="designation" label="Désignation">
                          </el-table-column>
                          <el-table-column prop="qte" label="Quantité">
                          </el-table-column>
                          <el-table-column prop="tourtes" label="Tourtes">
                          </el-table-column>

                          <el-table-column prop="metrage" label="Metrage">
                          </el-table-column>

                          <el-table-column prop="poidsBrute" label="Poids Brut (kg)">
                          </el-table-column>

                          <el-table-column prop="poidsNet" label="Poids Net (kg)">
                          </el-table-column>

                          <el-table-column prop="tare" label="Tare (kg)">
                          </el-table-column>
                        </el-table>
                      </div>
                    </el-col>
                  </el-row>
                </template>
              </el-table-column>


              <el-table-column prop="marque" label="Marque" sortable>
                <template slot-scope="item">
                  {{ item.row.marque }}
                </template>
              </el-table-column>
              <el-table-column prop="numeroConte" label="Numéro Conteneur"> </el-table-column>
              <el-table-column prop="numCle" label="Numéro clé"></el-table-column>
              <el-table-column prop="type" label="Type"></el-table-column>
              <el-table-column prop="poidsCargot" label="Poids cargot"></el-table-column>
              <el-table-column prop="nbPacket" label="Nombre de packet"></el-table-column>
              <el-table-column prop="tare" label="Tare"></el-table-column>
              <el-table-column prop="mesure" label="Mesure"></el-table-column>
            </el-table>
          </el-row>

          <v-tooltip top>
            <v-btn slot="activator" icons color="error"
              @click.stop="dialogShowLivraison = false, showBoat = false, showConteneurs = false" dark>Fermer <v-icon
                right>close</v-icon>
            </v-btn>
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn slot="activator" icons @click.stop="imprimerLivraison(livraisonCourant)" dark color="orange">
              Imprimer <v-icon right>print</v-icon>
            </v-btn>
            Imprimer la livraison
          </v-tooltip>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "search",
  props: {
    show: {
      type: Boolean
    },
    detailChantier: {
      type: Object
    }
  },
  data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
      user: JSON.parse(sessionStorage.getItem('userInfo')),
      roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
      droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
      loading: false,
      listResulat: [],
      typeRech: '',
      reference:'',
      valuetypeRech: '',
      formDmd: {
          chantier: '',
          autre:'',
          montant:5,
          demandeur:'',
          motif:'',
          projet:'',
          caisseSelect:''
            },

      //ONGLET TRAVAUX
      detailTravaux: {},
      dialogConfirmRefus: false,
      showRapport: false,
      showListeRapport: false,
      dialogListeRapport: false,
      dialogShowLivraison: false,
      dialogShowFacture: false,
      dialogShowCommande: false,
      valid: true,
      optionLivr: [],
      detailLivraison: [],
      projetS: '',
      chantierS: '',
      listeProjet:[],
      reloading:[],
      listeChantier:[],
      showBoat: false,
      showConteneurs: false,
      totalComHT: 0,
      totalComHTSR: 0,
      totalComRemise: 0,
      totalComTVA: 0,
      totalComTTC: 0,
      totComLigneTTC: 0,
      nomFourn: '',
      selectFourn: [],
      selectProjet:[],
      selectChantier: [],
      listFourn: [],
      showButon:false,
      showButonExcel: false,
      priorites: [
        {
          value: 'commande',
          label: "Commande"
        },
        {
          value: 'facture',
          label: "Facture"
        },
        {
          value: 'livraison',
          label: "Livraison"
        },
        {
          value: 'demandeFond',
          label: "Demande de Fond"
        }
      ],
      selectEtatDate: null,
      listCommande: [],
      idComm: '',
      detailCommande: [],
      livraisonCourant: [],
      commCourant: [],
      listFacture: [],
      factureCourant: [],
      detailFacture: [],
      listeRapports: [],
      periodeFormat: "",
      //ONGLET RESERVE
      listeReserves: [],
      //DASHBOARD TRAVAUX
      formRecherche: {
        commande: '',
        periode: '',
        facture: '',
        livraison: '',
        projet: '',
        chantier: ''
      }
    };
  },
  methods: {
    loadProjet () {
          let url = this.domaine + 'projet/index-projet-all'
          this.loading = true
          this.$http.get(url).then(response => {
              this.loading = false
                  this.listeProjet = response.body.projet
                  this.reloading = response.body.projet;
          },errRep=>{
                this.loading = false
              this.$message.error("Une erreur est survenue lors du chargement de la liste des projets")
          })
          },
          loadChantier (item)
            {
              if(item !='') {
                this.loading =  true
              //this.formDmd.chantier = '';
                let url = this.domaine + 'projet/'+ item +'/index/chantier'
                this.$http.get(url).then(response => {
                    this.loading = false
                    this.listeChantier = response.body.chantier
                    this.listeChantier.length > 0 ? (this.formDmd.chantier == this.listeChantier[0].id ): null
                },errRep=>{
                    this.loading = false
                    this.$message.error("Une erreur est survenue lors du chargement de la liste du chantier")
                })
              }
          },

          clearSelect(){
            this.listeProjet = this.reloading;
            },
            clrSelect() {
              console.log('enernr')
              this.listResulat = []
            },
          Selection(idProjet)
         {
          if(idProjet != ""){
            this.loadChantier(idProjet)
          }
            this.listeChantier.splice(0);  
         },
    closeDialog() {
      this.$emit("close");
    },
    headerRowStyle({ row, rowIndex }) {
      return { "color": "black" };
    },
    getSumm(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "Total";
          return;
        }

        if (index === 4) {
          sums[index] = "N/A";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = new Intl.NumberFormat().format(
            values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                let total = prev + curr
                return Math.round(total);
              } else {
                return prev;
              }
            }, 0)
          );
        } else {
          sums[index] = "N/A";
        }
      });

      return sums;
    },
    imprimerFacture(ligne) {
      let url = this.domaine + 'fournisseur/' + ligne.idFact + '/' + this.user.id + '/imprimer/facture'
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      })
      window.open(url)
    },
    imprimerCommande(ligne) {
      let url = this.domaine + 'fournisseur/' + ligne.id + '/imprimer/commande/' + this.user.id
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      })
      window.open(url)
    },
    imprimerLivraison(ligne) {
      let url = this.domaine + 'fournisseur/' + ligne.id + '/imprimer/livraison/' + this.user.id
      this.$http.get(url).then(response => {
        if (response.body) {
        }
      })
      window.open(url)
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    imprimerDemd(ligne) {
      this.loading = true;
      this.approCourant = ligne
      let url = this.domaine + 'demandeFond/' + ligne.id + '/' + this.user.id + '/imprimer/approvisionnement'
      this.$http.get(url).then(response => {
        this.loading = false;
        if (response.body) {
        }
      })
      window.open(url)
    },
    showInfo(row) {
      let totalHT = 0
      let totalTVA = 0
      let totalRemise = 0;
      switch (this.typeRech) {
        case 'commande':
          this.dialogShowCommande = true
          this.detailCommande = row
          this.optionLivr = row.optionLivr
          for (let option in row.option) {
            let item = row.option[option]
            let tmpTotalHTSRem = parseFloat(item.prix * item.qte)
            let mntRemise = 0;
            let remise = parseFloat(item.remise)
            if (remise > 0) {
              mntRemise = (tmpTotalHTSRem * remise) / 100
            }
            let tmpTotalHT = tmpTotalHTSRem - mntRemise;
            let tva = parseFloat(item.tva)
            let tmpTotalTVA = ((tmpTotalHT) * (tva / 100))
            totalTVA += tmpTotalTVA
            totalHT += tmpTotalHT
            totalRemise += mntRemise;
          }
          this.totalComHT = new Intl.NumberFormat().format(totalHT)
          this.totalComTVA = new Intl.NumberFormat().format(totalTVA)
          this.totalComRemise = new Intl.NumberFormat('fr-Fr').format(totalRemise)
          break;

        case 'livraison':
          this.dialogShowLivraison = true
          this.livraisonCourant = row
          if (this.detailLivraison) {
            if (this.detailLivraison[0].export) {
              this.showBoat = true
            }

            if (this.detailLivraison[0].conteneurs.length > 0) {
              this.showConteneurs = true
            }
          }

          for (let option in row.option) {
            let item = row.option[option]
            let tmpTotalHTSRem = parseFloat(item.prix * item.qte)
            let mntRemise = 0;
            let remise = parseFloat(item.remise)
            if (remise > 0) {
              mntRemise = (tmpTotalHTSRem * remise) / 100
            }
            let tmpTotalHT = tmpTotalHTSRem - mntRemise;
            let tva = parseFloat(item.tva)
            let tmpTotalTVA = ((tmpTotalHT) * (tva / 100))
            totalTVA += tmpTotalTVA
            totalHT += tmpTotalHT
            totalRemise += mntRemise;
          }
          this.totalComHT = new Intl.NumberFormat().format(totalHT)
          this.totalComTVA = new Intl.NumberFormat().format(totalTVA)
          this.totalComRemise = new Intl.NumberFormat('fr-Fr').format(totalRemise)

          break;

        case 'facture':
          this.dialogShowFacture = true
          this.detailFacture = row
          for (let option in row.option) {
            let item = row.option[option]
            let tmpTotalHTSRem = parseFloat(item.prix * item.qte)
            let mntRemise = 0;
            let remise = parseFloat(item.remise)
            if (remise > 0) {
              mntRemise = (tmpTotalHTSRem * remise) / 100
            }
            let tmpTotalHT = tmpTotalHTSRem - mntRemise;
            let tva = parseFloat(item.tva)
            let tmpTotalTVA = ((tmpTotalHT) * (tva / 100))
            totalTVA += tmpTotalTVA
            totalHT += tmpTotalHT
            totalRemise += mntRemise;
          }
          this.totalComHT = new Intl.NumberFormat().format(totalHT)
          this.totalComTVA = new Intl.NumberFormat().format(totalTVA)
          this.totalComRemise = new Intl.NumberFormat('fr-Fr').format(totalRemise)

          break;

        case 'approvisionnement':

          break;

        default:
          break;
      }

    },
    generateFile(format, etat) {
      this.loading = true
      var formdata = new FormData();

      formdata.append('idUser', this.user.id)
      formdata.append('typeRech', this.typeRech)
      formdata.append('chantier', this.chantierS)
      formdata.append('projet', this.projetS)
      formdata.append('periode', this.selectEtatDate)
      formdata.append('commande', this.reference)
      formdata.append('livraison', this.reference)
      formdata.append('facture', this.reference)
      formdata.append('fournisseur', this.selectFourn)


      let url = ''
      if (format == 'pdf') {
        url = this.domaine + "fournisseur/imprimerPDF/listeRecherche/" + etat;
        let req = new XMLHttpRequest();
        this.$http
          .post(url, formdata, { responseType: "arraybuffer" })
          .then(response => {
            let blob = new Blob([response.data], {
              type: response.headers.get("content-type")
            });
            let url = URL.createObjectURL(blob);
            this.loading = false;
            window.open(url);
          });

      } else {
        let idUser = this.user.id
        let typeRech = this.typeRech
        let commande =  this.reference ?  this.reference : null
        let periode =  this.selectEtatDate ? JSON.stringify(this.selectEtatDate) : null
        let fournisseur = this.selectFourn && this.selectFourn.length > 0 ?  this.selectFourn : null
        let projet = this.projetS ? this.projetS : null
        let chantier = this.chantierS ? this.chantierS : null
        console.log('ddd',this.selectFourn)
         url = this.domaine + "fournisseur/imprimerEXC/recherche/liste/"+idUser+'/'+typeRech+'/'+commande+'/'+fournisseur+'/'+projet+'/'+chantier+'/'+periode;
        this.loading = false
        window.open(url);
      }
    },
    loadFourn() {
      this.loading = true
      this.loadProjet();
      let url = ''
      url = this.domaine + 'fournisseur/index'
      this.$http.get(url).then(response => {
        if (response.body) {
          this.listFourn = response.body.fournisseur
          this.loading = false
        }
      })
    },
    imprimerInfo(row) {
      switch (this.typeRech) {
        case 'commande':
          this.imprimerCommande(row)
          break;

        case 'livraison':
          this.imprimerLivraison(row)
          break;

        case 'facture':
          this.imprimerFacture(row)
          break;

        case 'demandeFond':
          this.imprimerDemd(row)
          break;

        default:
          break;
      }


    },
    filtrerEtatPrioriteBesoin () {

    },
    
    loadTravaux() {

    },
    filtrerTravaux() {

    },
    loadBesoin() {

    },
    recherche() {
      this.loading = true
      this.listResulat = [];
      this.showButon = true      
      // let form = document.getElementById('formRech')
      let data = new FormData()
      let url = this.domaine + 'fournisseur/serach/globale'

      data.append('idUser', this.user.id)
      data.append('typeRech', this.typeRech)
      data.append('chantier', this.chantierS)
      data.append('projet', this.projetS)
      data.append('periode', this.selectEtatDate)
      data.append('commande', this.reference)
      data.append('livraison', this.reference)
      data.append('facture', this.reference)
      data.append('fournisseur', this.selectFourn)

      this.$http.post(url, data).then(response => {
        if (response.body) {
          this.showButonExcel = true
          let verif = response.body
          this.listResulat = response.body.result
          if (verif.code === 2) {
            this.$notify({
              title: 'RESULTATS DE VOTRE RECHERCHE',
              message: verif.message,
              type: 'success',
              position: 'top-center'
            })
          } else {
            this.$notify({
              title: 'RESULTATS DE VOTRE RECHERCHE',
              message: verif.message,
              type: 'warning',
              position: 'top-center'
            })
          }
          this.loading = false
        } else {
          this.$message.error('Erreur serveur')
          this.loading = false
        }
      },
        error => {
          this.$message.error('Erreur serveur')
          this.loading = false
        })
    },
  },
  mounted() {
    this.loadFourn();
  },
  computed: {
    desactiveBout: function () {

      return (this.formTri.periode == undefined);
    }
  },

};
</script>



// WEBPACK FOOTER //
// src/components/tierce/RechercheInfo.vue